<template>
  <div class="app" style="background-color: #242424;">
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="0">
            <img
              src="../../../assets/images/c4logo.png"
              style="width: 300px; height: auto; margin-bottom: 20px"
            />
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col md="8">
            <b-card-group>
              <b-card
                style="background-color: #ecc22e"
                no-body
                class="pb-1 pt-4 pl-4 pr-4"
              >
                <b-card-body style="background-color: #ecc22e">
                  <b-form @submit.prevent="tryToLogIn">
                    <h1>Login</h1>
                    <p class="text-muted">Sign In to your account</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="username"
                        :class="{ 'is-invalid': invalidData }"
                        type="text"
                        class="form-control"
                        name="username"
                        autocomplete="username email"
                      />
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock" />
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="password"
                        :class="{ 'is-invalid': invalidData }"
                        class="form-control"
                        name="password"
                        type="password"
                      />
                      <div class="invalid-feedback">
                        Please enter the correct username or password.
                      </div>
                    </b-input-group>
                    <b-row>
                      <b-col cols="6">
                        <b-button
                          :disabled="tryingToLogIn"
                          variant="dark"
                          class="px-4"
                          type="submit"
                          >Login</b-button
                        >
                      </b-col>
                      <b-col cols="6" class="text-right" />
                    </b-row>
                  </b-form>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { authMethods } from '@state/helpers'
import Layout from '@layouts/authentication'
import { Footer as TheFooter } from '@coreui/vue'

export default {
  page: {
    title: 'Login',
    meta: '',
  },
  components: { Layout, TheFooter },
  data() {
    return {
      username: '',
      password: '',
      tryingToLogIn: false,
      invalidData: false,
    }
  },
  mounted() {
    this.scrolltobottom()
  },

  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    scrolltobottom() {
      var elmnt = document.getElementById('app')
      elmnt.scrollIntoView()
    },

    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      return this.logIn({
        email: this.username,
        password: this.password,
      })
        .then(resp => {
          this.tryingToLogIn = false

          if (resp == false) {
            alert('invalide username or password')
          } else {
            window.localStorage.setItem(
              'auth.authDetails',
              JSON.stringify(resp.docs[0])
            )
            this.$router.push(
              this.$route.query.redirectFrom || { name: 'home' }
            )
          }

          // Redirect to the originally requested page, or to the home page
        })
        .catch(error => {
          this.invalidData = true
          this.tryingToLogIn = false
          this.authError = error
        })
    },
  },
}
</script>
